import React from 'react';
import { messageUtility } from '../../utilities/messageUtility';
import { Information } from './common';

export const DownloadFileErrorDialog = ({ visible, onClose }) => (
  <Information
    visible={visible}
    title='ダウンロードエラー'
    message={messageUtility.getMessage('E-000-033')}
    buttonText={messageUtility.getMessage('I-000-008')}
    onClose={onClose}
    buttonClassName='btn--sm--sub'
  />
);



// WEBPACK FOOTER //
// ./src/components/modals/DownloadFileErrorDialog.jsx